
















































import Api from "@/api/Api";
import { Advertiser } from "@/interfaces/advertiser";
import Vue, { PropType } from "vue";
export default Vue.extend({
  props: {
    advertiser: Object as PropType<Advertiser>
  },
  data() {
    return {
      active: false,
      updatePassword: {
        newPassword: "",
        newPasswordConfirm: ""
      },
      errors: {}
    };
  },
  methods: {
    async exec(cb: () => void) {
      this.errors = {};
      if (!this.advertiser) {
        return;
      }
      try {
        await Api.singleton().call({
          method: "PATCH",
          resource: this.advertiser.owner + "/update_password",
          body: this.updatePassword
        });
        this.active = false;
        this.$emit("success");
      } catch (violations) {
        for (const v of violations) {
          this.$set(this.errors, v.propertyPath, v.message);
        }
      }
      cb();
    }
  }
});
